import fields from "../global/fields";
import fields_admin from "../app_immobilienwerker_de/fields_admin";
import FormHelptext from "../products/formHelptext";

export default {
  methods: {
    parseFloatIntoEuro(x, withEuroSymbol = false, digits = 2) {
      const parsedValue = parseFloat(x);
      if (isNaN(parsedValue)) return "0" + (withEuroSymbol ? " €" : "");

      return parseFloat(x).toLocaleString("de-DE", {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits
      }) + (withEuroSymbol ? " €" : "");
    },

    generateOptions(min, max, step) {
      let options = [];
      for (let i = min; i <= max; i = parseFloat((i + step).toFixed(2))) {
        options.push(i);
      }
      return options;
    },
    scrollTo(targetElem) {
      let elem = document.querySelector(targetElem);
      if (!elem) return;
      elem.scrollIntoView({ behavior: "smooth" });
    },
    floatIntoGermanFormat(input, digits = 2) {
      if (!input) return 0;
      return parseFloat(input).toFixed(digits).replace(".", ",");
    },
    getFullFloorHeight() {
      let options = [];

      for (let i = 2; i <= 4; i += 0.05) {
        options.push(parseFloat(i.toFixed(2))); // floating point accuracy
      }

      return options;
    },
    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds));
    },

    isProduction() {
      return process.env.MIX_APP_ENV === "production";
    },
    isMitarbeiterportal() {
      return process.env.MIX_PROJECT.startsWith("app_");
    },

    formatDate(date, format = "DD.MM.YYYY") {
      if (!date) return "-";
      let formattedDate = this.$moment(date).locale("de");
      return formattedDate.isValid() ? formattedDate.format(format) : "-";
    },

    setCookie(string, cookieName = "form_session", minutes = 60 * 24 * 365) {
      // 1) Server-side set to support HttpOnly and parent-domain cookies
      try {
        if (typeof axios !== "undefined") {
          axios.post("/api/cookie/set", { name: cookieName, value: string, minutes }).catch(() => {
            // ignore network errors silently for this helper
          });
        }
      } catch (e) {
        // no-op
      }

      // // 2) Client-side set as best-effort (non-HttpOnly, current host)
      // try {
      //   let date = new Date();
      //   date.setTime(date.getTime() + (minutes * 60 * 1000));
      //   let expires = "expires=" + date.toUTCString();
      //   document.cookie = `${cookieName}=` + string + ";" + expires + ";path=/;secure";
      // } catch (e) {
      //   // ignore
      // }
    },
    async setCookieAsync(string, cookieName = "form_session", minutes = 60 * 24 * 365) {
      // 1) Server-side set to support HttpOnly and parent-domain cookies
      try {
        if (typeof axios !== "undefined") {
          await axios.post("/api/cookie/set", { name: cookieName, value: string, minutes }).catch(() => {
            // ignore network errors silently for this helper
          });
        }
      } catch (e) {
        // no-op
      }
    },

    getCookieValue(cookieName) {
      const cookieMatch = document.cookie.match("(^|;)\\s*" + cookieName + "\\s*=\\s*([^;]+)");
      return cookieMatch ? cookieMatch.pop() : "";
    },

    removeParameterFromUrl(parameter) {
      let query = Object.assign({}, this.$route.query);
      delete query[parameter];
      this.$router.replace({ query });
    },

    fieldcode(path) {
      return path.split(".").reduce((current, key) => current ? current[key] : undefined, fields);
    },

    fields_admin(path) {
      return path.split(".").reduce((current, key) => current ? current[key] : undefined, fields_admin);
    },

    helptext(column) {
      if (column.includes(".")) {
        return column.split(".").reduce((current, key) => current ? current[key] : undefined, FormHelptext);
      }
      return FormHelptext[column];
    },

    formatHumanize(date) {
      let formattedDate = this.$moment(date);
      if (!formattedDate.isValid()) {
        return "-";
      }
      let daysDiff = this.$moment(date).diff(this.$moment(), "minutes");
      return this.$moment.duration(daysDiff, "minutes").humanize(true, { m: 60, h: 24, d: 7, w: 4 });
    },

    getGermanTime(dateTime, format = "DD.MM.YYYY HH:mm") {
      const berlinTimeZone = "Europe/Berlin";
      const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (currentTimeZone !== berlinTimeZone) {
        const options = {};

        if (format.includes("DD")) options.day = "2-digit";
        if (format.includes("MM")) options.month = "2-digit";
        if (format.includes("YYYY")) options.year = "numeric";
        if (format.includes("HH")) {
          options.hour = "2-digit";
          options.hour12 = false;
        }
        if (format.includes("mm")) options.minute = "2-digit";

        return new Date(dateTime).toLocaleTimeString("de-DE", { timeZone: berlinTimeZone, ...options });
      }
      return "";
    },

    setHelpTextColumn(string) {
      this.$nextTick(_.debounce(() => {
        this.setHelpLabelPosition(string);
        EventBus.$emit("setHelpTextColumn", string);
      }, 200));
    },

    setProductByEmit(product) {
      EventBus.$emit("setProductByEmit", product);
    },

    setHelpLabelPosition(labelName) {
      this.$nextTick(_.debounce(() => {
        let labelElement = $(`#lable${CSS.escape(labelName)}`);
        let labelPosition = 0;
        if (labelElement.length) {
          let offset = 0;
          if (labelElement.length && $(`.formApplicationComponent`).length && $(`.formApplicationComponent`).offset()) {
            offset = $(`.formApplicationComponent`).offset().top;
          }
          labelPosition = labelElement.offset().top - offset;
        } else {
          if (!this.isProduction())
            console.warn(`Element #lable${labelName} nicht gefunden.`);
          return;
        }

        let calculatedHeight = labelPosition || 100;
        $(".rightHelpTextBox").css({ "margin-top": (calculatedHeight) + "px" });
      }, 10));
    },

    copyToClip(value, message = "In die Zwischenablage kopiert") {
      if (!value) return;
      this.$copyText(value);
      EventBus.$emit("show-snackbar", {
        message: message
      });
    },

    includeScript(scriptUrl) {
      this.includeScriptWithCallback(scriptUrl);
    },

    includeScriptWithCallback(scriptUrl, callback) {
      const scripts = document.getElementsByTagName("script");
      let alreadyIncluded = false;

      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute("src") === scriptUrl) {
          alreadyIncluded = true;
          if (callback && typeof callback === "function") {
            callback();
          }
          break;
        }
      }

      if (!alreadyIncluded) {
        var script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        script.defer = true;

        script.onload = function() {
          if (callback && typeof callback === "function") {
            callback();
          }
        };

        document.head.appendChild(script);
      }
    }
  }
};
